export const getMedicationWorks = `
    id
    works {
        id
        dateFrom
        dateTo
        workType
        users {
            id
            name
            surname
            email
            titleAfterName
            titleBeforeName
        }
    }
`;
